(function () {
  'use strict';

  var mounted = new Map();

  function rootsWithin(scope, selector) {
    var roots = [];
    if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
    if (scope.querySelectorAll) roots.push.apply(roots, scope.querySelectorAll(selector));
    return roots;
  }

  function mount(root, initializer) {
    if (mounted.has(root)) return;
    var controller = new AbortController();
    mounted.set(root, controller);
    initializer(root, controller.signal);
  }

  function unmountWithin(scope) {
    mounted.forEach(function (controller, root) {
      if (root === scope || (scope.contains && scope.contains(root))) {
        controller.abort();
        mounted.delete(root);
      }
    });
  }

  function parsePrice(value) {
    var number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatMoney(value) {
    return '$' + value.toFixed(2);
  }

  function initHero(root) {
    var rays = root.querySelector('.winks-hero__rays');
    if (!rays || rays.dataset.ready === 'true') return;

    var fragment = document.createDocumentFragment();
    for (var index = 0; index < 18; index += 1) {
      var ray = document.createElement('div');
      ray.className = 'winks-ray';
      ray.style.transform = 'translate(-50%, -50%) rotate(' + (index * 20) + 'deg) translateY(-235px)';
      fragment.appendChild(ray);
    }
    rays.appendChild(fragment);
    rays.dataset.ready = 'true';
  }

  function initBuybox(root, signal) {
    var quantity = 1;
    var plan = 'sub';
    var quantityButtons = Array.from(root.querySelectorAll('.winks-qty[data-qty]'));
    var planCards = Array.from(root.querySelectorAll('.winks-plan'));
    var productCta = root.querySelector('[data-winks-product-cta]');
    var mediaPanels = Array.from(root.querySelectorAll('[data-winks-media-panel]'));
    var mediaButtons = Array.from(root.querySelectorAll('[data-winks-media-button]'));

    var prices = planCards.reduce(function (result, card) {
      var key = card.dataset.plan;
      var amount = card.querySelector('[data-price-' + key + ']');
      if (key && amount) result[key] = parsePrice(amount.dataset['price' + key.charAt(0).toUpperCase() + key.slice(1)]);
      return result;
    }, {});

    function renderPrice(card) {
      var key=card.dataset.plan;
      if(!(key in prices))return;
      var suffix=key[0].toUpperCase()+key.slice(1),amount=card.querySelector('[data-price-'+key+']'),strike=card.querySelector('[data-price-'+key+'-strike]');
      if(amount)amount[key==='sub'?'innerHTML':'textContent']=formatMoney(prices[key]*quantity)+(key==='sub'?'<small>/mo</small>':'');
      if(strike)strike.textContent=formatMoney(parsePrice(strike.dataset['price'+suffix+'Strike'])*quantity);
    }

    function render() {
      quantityButtons.forEach(function (button) {
        var active = Number(button.dataset.qty) === quantity;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      planCards.forEach(function (card) {
        var selected = card.dataset.plan === plan;
        card.classList.toggle('selected', selected);
        var radio = card.querySelector('input[type="radio"]');
        if (radio) radio.checked = selected;
        renderPrice(card);
      });

      if (!productCta || !prices[plan]) return;
      var label = quantity === 1 ? productCta.dataset.labelSingle : productCta.dataset.labelMultiple;
      var suffix = plan === 'sub' ? '/mo' : '';
      productCta.innerHTML = label + ' <span data-winks-cta-price>' + formatMoney(prices[plan] * quantity) + suffix + '</span>';
    }

    function showMedia(mediaId) {
      mediaPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.winksMediaPanel !== mediaId;
      });
      mediaButtons.forEach(function (button) {
        var selected = button.dataset.winksMediaButton === mediaId;
        button.classList.toggle('active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    quantityButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        quantity = Number(button.dataset.qty) || 1;
        render();
      }, { signal: signal });
    });

    planCards.forEach(function (card) {
      card.addEventListener('click', function () {
        plan = card.dataset.plan || 'sub';
        render();
      }, { signal: signal });
    });

    mediaButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        showMedia(button.dataset.winksMediaButton || '1');
      }, { signal: signal });
    });

    render();
  }

  function initFaq(root, signal) {
    root.querySelectorAll('.winks-faq__q').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.winks-faq__item');
        if (!item) return;
        var open = item.classList.contains('open');

        root.querySelectorAll('.winks-faq__item.open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('open');
          var otherButton = other.querySelector('.winks-faq__q');
          if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
        });

        item.classList.toggle('open', !open);
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
      }, { signal: signal });
    });
  }

  function initFooter(root, signal) {
    var mobile = window.matchMedia('(max-width: 560px)');
    var columns = Array.from(root.querySelectorAll('.winks-footer__col'));

    columns.forEach(function (column) {
      var heading = column.querySelector('h4');
      var list = column.querySelector('ul');
      if (!heading || !list) return;

      heading.tabIndex = 0;
      heading.setAttribute('role', 'button');

      function sync() {
        if (!mobile.matches) {
          list.hidden = false;
          heading.setAttribute('aria-expanded', 'true');
        } else if (!heading.hasAttribute('data-winks-touched')) {
          list.hidden = true;
          heading.setAttribute('aria-expanded', 'false');
        }
      }

      function toggle() {
        if (!mobile.matches) return;
        heading.setAttribute('data-winks-touched', 'true');
        list.hidden = !list.hidden;
        heading.setAttribute('aria-expanded', list.hidden ? 'false' : 'true');
      }

      heading.addEventListener('click', toggle, { signal: signal });
      heading.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggle();
      }, { signal: signal });
      mobile.addEventListener('change', sync, { signal: signal });
      sync();
    });
  }

  function initialize(scope) {
    rootsWithin(scope, '.winks-hero').forEach(function (root) { mount(root, initHero); });
    rootsWithin(scope, '.winks-buybox').forEach(function (root) { mount(root, initBuybox); });
    rootsWithin(scope, '.winks-faq').forEach(function (root) { mount(root, initFaq); });
    /* Swipe carousels live in winks-swipe.js and mount themselves. */
    rootsWithin(scope, '.winks-footer').forEach(function (root) { mount(root, initFooter); });
  }

  function start() {
    initialize(document);
    document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmountWithin(event.target); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
